import { API } from '../../../api';
import { axiosInstance } from '../../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getClaimsTypesEffectCancelToken = () => {};
export const getPreClaimsTypes = () => {
  getClaimsTypesEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetClaimType`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getClaimsTypesEffectCancelToken = c;
    }),
  });
};

let getClaimsReasonTypeEffectCancelToken = () => {};
export const getPreClaimsReasonTypeEffect = () => {
  getClaimsReasonTypeEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetClaimReasonType`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getClaimsReasonTypeEffectCancelToken = c;
    }),
  });
};

let getClaimsReasonEffectCancelToken = () => {};
export const getPreClaimsReasonEffect = () => {
  getClaimsReasonEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetReason`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getClaimsReasonEffectCancelToken = c;
    }),
  });
};

let getClaimsDocumentTypesEffectCancelToken = () => {};
export const getPreClaimsDocumentTypesEffect = () => {
  getClaimsDocumentTypesEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetDocumentType`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getClaimsDocumentTypesEffectCancelToken = c;
    }),
  });
};

export const getPreClaimsShipperConsigneeByShortNameEffect = (ShortName) => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetShipperConsignee`,
    method: 'get',
    params: { ShortName },
  });
};

export const getPreClaimsFullReleaseListEffect = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetFullReg`,
    method: 'get',
  });
};

export const getPreClaimsDispositionMethodListEffect = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetDispositionMethod`,
    method: 'get',
  });
};

export const getPreClaimsPercentageOrValueListEffect = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetPercentageOrValue`,
    method: 'get',
  });
};

export const getPreClaimsMitigatedTypesEffect = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetMitigatedType`,
    method: 'get',
  });
};

export const createPreClaimsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/SaveClaim`,
    method: 'post',
    data,
  });
};

let checkDuplicatePreClaimEffectCancelToken = () => {};
export const checkDuplicatePreClaimEffect = (params) => {
  checkDuplicatePreClaimEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PRECLAIM}/CheckDuplicateClaim`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      checkDuplicatePreClaimEffectCancelToken = c;
    }),
  });
};
